import React, { useState, useRef, useEffect } from 'react';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { GrClose } from 'react-icons/gr';
import SearchInput from '../SearchInput/SearchInput';
import MenuBoldItem from '../MenuItems/MenuBoldItem/MenuBoldItem';
import MenuNormalItem from '../MenuItems/MenuNormalItem/MenuNormalItem';
import { MdArrowForwardIos } from 'react-icons/md';
import { BiWorld } from 'react-icons/bi';
import SocialNetworks from '../SocialNetworks/SocialNetworks';
import { BsCheck2 } from 'react-icons/bs';
import data from '../../data/data';
import settings from '../../data/settings';
import ConvertHTMLString from '../../helperFunctions/ConvertedHTMLString';

const MenuContentOnePageAllOpen = ({ onClick, isOpen, setIsOpen }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [customHTML, setCustomHTML] = useState(null);

  const toggleSubmenu = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [menuItems, setMenuItems] = useState(data.menu_items);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [language, setLanguage] = useState('');
  const [searchInfo, setSearchInfo] = useState('');
  const [selectedLanguageInitials, setSelectedLanguageInitials] = useState('');
  const [availableLanguages, setAvailableLanguages] = useState([]);

  const [navigationContentAlignment, setNavigationContentAlignment] =
    useState(null);

  const [menuBackgroundColor, setMenuBackgroundColor] = useState('#fff');
  const [isLanguageSwitcherVisible, setIsLanguageSwitcherVisible] = useState(
    settings.lang_switcher_visibility
  );
  const [closeButtonAlignment, setCloseButtonAlignment] = useState('end');
  const [socialNetworksAlignment, setSocialNetworksAlignment] = useState('end');
  const [isButtonAnimated, setIsButtonAnimated] = useState(false);

  useEffect(() => {
    setIsLanguageSwitcherVisible(settings.lang_switcher_visibility);
    setIsButtonAnimated(settings.animated_menu_button);
    if (settings.alignment.navigation_content === 'left') {
      setNavigationContentAlignment('left');
    }
    if (settings.alignment.navigation_content === 'center') {
      setNavigationContentAlignment('center');
    }
    if (settings.alignment.navigation_content === 'right') {
      setNavigationContentAlignment('right');
    }
  }, []);

  const [hover, setHover] = useState(false);
  const hoverStyle = {
    color: hover
      ? settings.colors.link_hover_color
      : settings.colors.font_color_regular,
  };

  const ref = useRef();

  const url = data.search_url;

  useOnClickOutside(ref, () => {
    setIsLanguageMenuOpen(false);
  });

  const handleOnChange = (e) => {
    setSearchInfo(e.target.value);
  };

  const handleClick = () => {
    window.location = url.replace('{needle}', `${searchInfo}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      window.location = url.replace('{needle}', `${searchInfo}`);
    }
  };

  useEffect(() => {
    const refactorSelectedLang = (lang) => {
      return lang.replace('_', '-');
    };

    const choseLanguageByLangInitials = (languageInitials) => {
      if (data.available_languages.length > 0) {
        const result = data.available_languages.filter(
          (language) => refactorSelectedLang(languageInitials) === language.lang
        );
        return result[0].name;
      } else {
        console.log('There are no available languages!');
      }
    };

    setCustomHTML(ConvertHTMLString(data.custom_html));
    setAvailableLanguages(data.available_languages);
    const selectedLanguageInitials = refactorSelectedLang(data.selected_lang);
    setSelectedLanguageInitials(selectedLanguageInitials);
    const chosenLanguage = choseLanguageByLangInitials(
      selectedLanguageInitials
    );
    setLanguage(chosenLanguage);
  }, []);

  useEffect(() => {
    setMenuBackgroundColor(settings.colors.navigation_background_color);
  }, []);

  useEffect(() => {
    // Close button alignment
    if (settings.alignment.close_navigation_button === 'right') {
      setCloseButtonAlignment('end');
    } else {
      setCloseButtonAlignment('start');
    }

    // Social networks alignment
    if (settings.alignment.social_icons === 'right') {
      setSocialNetworksAlignment('end');
    } else if (settings.alignment.social_icons === 'center') {
      setSocialNetworksAlignment('center');
    } else {
      setSocialNetworksAlignment('start');
    }
  }, []);

  return (
    <div
      className={`flex flex-col justify-between h-full viergrad-custom-menu-font-regular ${
        settings.searchbar_visibility ? 'pt-16' : 'pt-0'
      }`}
    >
      <div className='flex flex-col justify-start w-full'>
        {!isButtonAnimated ? (
          <div
            // className='self-end pr-[30px] sm:pr-[24px] hover:cursor-pointer'
            className={`self-${closeButtonAlignment} px-[30px] sm:px-[24px] mt-[-2.2rem] sm:mt-[-2.5rem]  hover:cursor-pointer`}
            onClick={onClick}
          >
            <GrClose fontSize='1.5rem' />
          </div>
        ) : null}
      </div>
      <div className='mx-8 pt-8 sm:pl-16 sm:pr-16'>
        <SearchInput
          onChange={handleOnChange}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className='h-full flex flex-col justify-between'>
        <ul className='h-full d-flex pt-14 pb-4 sm:pl-16 sm:pr-16'>
          <div
            className='h-full'
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {/* MENU ITEMS PART */}
            <div>
              {menuItems.map((item, index) => (
                <div>
                  <MenuBoldItem
                    name={item.name}
                    key={index}
                    multilevel={item.multiLevel}
                    isClicked={null}
                    href={item.href}
                    target={item.target}
                  />
                  <ul
                    className={item.multiLevel > 0 ? 'px-8 py-4' : 'px-0 py-0'}
                  >
                    {item.submenuFirstLevel &&
                      item.submenuFirstLevel.map((subitem, subIndex) => (
                        <MenuNormalItem
                          key={subIndex}
                          name={subitem.name}
                          style={{
                            paddingTop: '0px',
                            paddingBottom: '0px',
                          }}
                          href={subitem.href}
                          target={subitem.target}
                          className='menu-item-is-children'
                        />
                      ))}
                  </ul>
                </div>
              ))}
              {/* CUSTOM HTML PART */}
              <div
                dangerouslySetInnerHTML={{ __html: customHTML }}
                className='px-8 py-8 custom-html-element'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent:
                    navigationContentAlignment === 'left'
                      ? 'flex-start'
                      : navigationContentAlignment === 'right'
                      ? 'flex-end'
                      : 'center',
                }}
              ></div>
            </div>

            {/* SOCIAL NETWORKS AND LANGUAGE SWITCHER PART */}
            <div ref={ref} className='flex flex-col pt-16'>
              {!isLanguageMenuOpen ? (
                <div
                  className='sm:pr-0'
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: socialNetworksAlignment,
                  }}
                >
                  <SocialNetworks />
                </div>
              ) : (
                <div className='flex flex-col sm:pl-16 py-5 bg-transparent viergrad-custom-menu-font-regular'>
                  {data.available_languages.map((language) => {
                    return (
                      <div
                        className='flex flex-row justify-start left-2 py-2 mx-8 hover:cursor-pointer'
                        style={hoverStyle}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={() => {
                          setLanguage(language.name);
                          setSelectedLanguageInitials(language.lang);
                        }}
                      >
                        <div className='flex items-center pt-1 pl-1 pr-3.5 gap-3'>
                          {language.lang === selectedLanguageInitials ? (
                            <BsCheck2 />
                          ) : (
                            <BsCheck2
                              style={{
                                visibility: 'hidden',
                              }}
                            />
                          )}
                        </div>
                        {language.lang === selectedLanguageInitials ? (
                          <div>{language.name}</div>
                        ) : (
                          <a href={language.href} style={{ width: '100%' }}>
                            <div>{language.name}</div>
                          </a>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {availableLanguages.length > 0 || isLanguageSwitcherVisible ? (
                <div
                  className='flex flex-col bg-transparent'
                  //   style={hoverStyle}
                  //   onMouseEnter={() => setHover(true)}
                  //   onMouseLeave={() => setHover(false)}
                >
                  <div
                    //   className='flex flex-row justify-between bg-transparent py-5 text-darkFontColor hover:text-turquoise hover:cursor-pointer'
                    className={`flex flex-row justify-between bg-transparent py-5 text-[${settings.colors.font_color_regular}] hover:[${settings.colors.link_hover_color}] hover:cursor-pointer`}
                    onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
                  >
                    <div className='flex flex-row justify-start gap-3 mx-7 pl-2 sm:pl-0 left-0 right-0 '>
                      <div
                        className='pt-0.25 text-2xl'
                        style={{ color: settings.colors.font_color_regular }}
                        // style={hoverStyle}
                        // onMouseEnter={() => setHover(true)}
                        // onMouseLeave={() => setHover(false)}
                      >
                        <BiWorld />
                      </div>
                      <span
                        className='viergrad-custom-menu-font-regular'
                        style={{ color: settings.colors.font_color_regular }}
                        // style={hoverStyle}
                        // onMouseEnter={() => setHover(true)}
                        // onMouseLeave={() => setHover(false)}
                      >
                        {language}
                      </span>
                    </div>
                    <div
                      className='pr-8 sm:pr-0 sm:mr-8 pt-0.5 font-bold text-xl'
                      style={{ color: settings.colors.font_color_regular }}
                      //   style={hoverStyle}
                      //   onMouseEnter={() => setHover(true)}
                      //   onMouseLeave={() => setHover(false)}
                    >
                      <MdArrowForwardIos />
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default MenuContentOnePageAllOpen;
